import hvcb72dt from "../../../../assets/images/productos/hvcb72DT/HVCB 72 DT 2.png";
import qr from "../../../../assets/images/QR Alberto Agliano.svg";
import Producto from "../../../../components/producto";

import { useTranslation } from "react-i18next";

function HVCB72DT() {

  const { t } = useTranslation();

  return (
    <Producto
      fotos={[]}
      datosTabla1={[
        [t("tensionNominalMaxima"), "kV", "72,5"],
        [t("corrienteNominal"), "A", "1200 / 2000 / 3000 / 4000"],
        [t("capacidadNominalDeInterrupcionSimetrica"), "kA", "40"],
        [t("corrienteNorminalAdmisibleDeCortaDuracion"), "kA (3sec)", "40"],
        [t("corrienteNominalDeCierreDeCortocircuito"), "kV", "108"],
        [t("tensionDeResistenciaAlImpulsoAtmosferico"), "kV", "350"],
        [t("tensionDeResistenciaAlImpulsoAtmosfericoConContactosAbiertos"), "kV", "350"],
        [t("frecuenciaNominal"), "Hz", "50/60"],
        [t("tensionNominalDeResistenciaAFrecuenciaIndustrial"), "kV", "160"],
        [t("tensionDeResistenciaALaFrecuenciaIndustrialConContactosAbiertos"), "kV", "160"]
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "3.017"],
        [t("alto"), "mm", "3.528"],
        [t("profundidad"), "mm", "2.919"],
      ]}
      nombreProducto={"HVCB 72 DT"}
      fotoProducto={hvcb72dt}
      descripcionProducto={
        t("hvcb72dt.titulo_descripcion")
      }
      caracteristicas={[
      ]}
      vendedor={{
        nombre: "Alberto Agliano",
        telefono: "+54 9 11 5096-5598",
        mail: "apagliano@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2026%20-%20HVCB%2072.pdf'}
    />
  );
}

export default HVCB72DT;